var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Nav'),_c('v-main',{staticStyle:{"background-color":"#f0f2f5"}},[_c('AccessGuard'),(_vm.visible)?_c('router-view'):_vm._e()],1),_c('Footer'),_c('LoadPOS'),_c('OrderDetail'),_c('VoidCharge'),_c('InvoiceDetail'),_c('OrdersDialog'),_c('PhotoDialog'),_c('VirtualTerminal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }